// Import component
import hamburger from '../../components/02-atoms/hamburger/hamburger';
import footer from '../../components/03-molecules/04-footer/footer.js';
import search from '../../components/03-molecules/03-search/search.js';
import userMenu from '../../components/03-molecules/user-menu/user-menu.js';
import websiteSwitcher from '../../components/03-molecules/website-switcher/website-switcher.js';
import accordion from '../../components/04-organisms/00-accordion/accordion.js';
import mainNavigation from '../../components/04-organisms/01-main-navigation/main-navigation';
import swipe from '../../components/04-organisms/swipe/swipe.js';
import stickyBar from '../../components/03-molecules/20-sticky-bar/sticky-bar.js';
import contentFilterView from "../../components/04-organisms/content-filter-view/content-filter-view.js";


/** Run Order:
 *  newsArchive must be initialized before the tabs because the archive has event listeners that must listen before
 *  the tabs are used
 */
hamburger();
mainNavigation();
accordion();
websiteSwitcher();
userMenu();
search();
footer();
stickyBar();
contentFilterView();

/**
 * module Swipe
 */
const swipes = document.getElementsByClassName("js-swipe");
if(swipes.length > 0) {
    Array.prototype.forEach.call(swipes, function(swipeModule) {
    new swipe(swipeModule);
  });
}
